import dayjs from 'dayjs';
import constants from '../shared/constants';

export function generateHeadersForMonth(firstDayEpoch :any, lastDayEpoch:any): string[] {
		const startDate = dayjs(firstDayEpoch);
    const endDate = dayjs(lastDayEpoch);
    const daysInMonth = startDate.daysInMonth();
    const headers: string[] = ['Employee Name', 'ProjectName', 'Category', 'Feature'];

    let currentDate = startDate.clone();
    while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
        headers.push(currentDate.format(constants.DATE_FORMAT));
        currentDate = currentDate.add(1, 'day');
    }

    return headers;
	}